module.exports = __webpack_public_path__ + "static/media/11807552_10207087102156471_6090670590219694714_o.36c88e52.jpg";